const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const spinnerStyle = {
  width: 48,
  height: 48,
  border: "4px solid rgba(255, 255, 255, 0.3)",
  borderTopColor: "#fff",
  borderRadius: "50%",
  animation: "reconnecting-spin 0.8s linear infinite",
};

const textStyle = {
  color: "#fff",
  fontSize: 18,
  marginTop: 16,
  fontWeight: 500,
};

export const ReconnectingOverlay = () => (
  <div style={overlayStyle} role="alert" aria-atomic="true">
    <style>{`@keyframes reconnecting-spin { to { transform: rotate(360deg); } }`}</style>
    <div style={spinnerStyle} aria-hidden="true" />
    <div style={textStyle}>Reconnecting...</div>
  </div>
);
